/* eslint-disable no-console */
import type { AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import { compressGzip, isGzipSupported } from '../../helpers/compression';
import type { BatchLogPayload } from './types';

const RETRY_COUNT = 2;
const RETRY_DELAY_IN_MS = 1500;

export default class LogApi {
  private readonly api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
    axiosRetry(this.api, {
      retries: RETRY_COUNT,
      shouldResetTimeout: true,
      retryDelay: (retryCount) => retryCount * RETRY_DELAY_IN_MS,
      retryCondition: (error) => /^\/?log\//.test(error.config?.url ?? '') || false,
    });
  }

  async batch(payload: BatchLogPayload): Promise<void> {
    try {
      if (isGzipSupported()) {
        const compressed = await compressGzip(JSON.stringify(payload));
        await this.api.post('/log/batch', compressed, {
          headers: {
            'Content-Encoding': 'gzip',
            'Content-Type': 'application/json',
          },
        });

        return;
      }

      await this.api.post('/log/batch', payload);
    } catch (error) {

      console.info('Failed to send logs batch', error);
    }
  }
}
